import { Button, Checkbox, Space, Table } from "antd";
import React from "react";
import PageHeader from "../../PageHeader";
import AddNewIcon from "../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../assets/icons/delete.png";
import EditIcon from "../../../assets/icons/edit.png";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
const ManageOrganization = () => {
  const history = useHistory();
  const orgs = useSelector((state) => state?.companySetting?.orgs);
  const columns = [
    {
      title: "Branch Name",
      dataIndex: "org_name",
      key: "org_name",
      //   render: text => <a href="/">{text}</a>,
    },
    {
      title: "Primary email",
      dataIndex: "primary_email",
      key: "primary_email",
    },
    {
      title: "Primary contact",
      dataIndex: "primary_contact",
      key: "primary_contact",
    },
    {
      title: "Contact Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Enable",
      dataIndex: "is_active",
      key: "is_active",
      render: (text) => <Checkbox checked={true} />,
    },
    {
      title: "Actions",
      key: "action",
      render: (text, record) => (
        <Space key={record.id} size="middle">
          <button onClick={(e) => {}}>
            <img src={EditIcon} alt={"logo"} className="action-logo" />
          </button>
          <button onClick={(e) => {}}>
            <img src={DeleteIcon} alt={"logo"} className="action-logo" />
          </button>
        </Space>
      ),
    },
  ];

  const data = [
    {
      org_name: "Paycraft Info Ltd",
      primary_email: "abhishek@paycraftsol.info",
      primary_contact: 8973843843,
      name: "Abhishek",
    },
  ];

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Manage Branch`}
          navigation={{
            Home: "/dashboard/",
            
            "Manage Branch": null,
          }}
        />
      </div>
      <Button
        onClick={() => {
          history.push("/setting/organisation/add");
        }}
        className="mb1 addNew primaryButton"
      >
        <img src={AddNewIcon} alt={"logo"} className="addNew-logo " />
        Add New Branch
      </Button>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={[...data, ...orgs]}
        className="settingsTable"
      />
    </>
  );
};

export default ManageOrganization;
